import {
  createContext,
  useContext,
  useState,
  useMemo,
  useCallback,
  memo,
  ReactNode,
} from "react";

const ViewPortContext = createContext<any>({
  viewportXvalue: 0,
  viewportYvalue: 0,
  getViewPortXYValue: () => {},
});
export const useViewPortContext = () => useContext(ViewPortContext);

const ViewPortProvider = ({ children }: { children: ReactNode }) => {
  const [viewportXvalue, setViewportXvalue] = useState<any>(0);
  const [viewportYvalue, setViewportYvalue] = useState<any>(0);

  const getViewPortXYValue = useCallback((x: any, y: any) => {
    setViewportXvalue(x);
    setViewportYvalue(y);
  }, []);

  const contextValue = useMemo(
    () => ({
      viewportXvalue,
      viewportYvalue,
      getViewPortXYValue,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewportXvalue, viewportYvalue]
  );

  return (
    <ViewPortContext.Provider value={contextValue}>{children}</ViewPortContext.Provider>
  );
};

export default memo(ViewPortProvider);
